<template>
  <div>
    <label class="mr-sm-2 mb-3 font-weight-bolder d-block">
      <i :class="'fas fa-' + filter_icon"></i>
      <span class="ml-2">{{ $t(filter_text) }}</span>
    </label>
    <span
      v-if="filters !== null"
      v-for="filters, index in value"
      class="tag is-info wrap-badge"
    >
      <span v-if="filters.length > 0">
        <span v-if="tabs == true">
          <span v-if="index != 'p_open'">
            {{ $t(filters) | formatDate(locale, index) }}
            <a class="close" @click="remove(index)"></a>
            {{ set_filters = '' }}
          </span>
        </span>
        <span v-else>
          {{ $t(filters) | formatDate(locale, index) }}
          <a class="close" @click="remove(index)"></a>
          {{ set_filters = '' }}
        </span>
      </span>
    </span>
    <p class="text-right" v-if="set_filters !== false">
      <b-button @click="removeAll">{{$t('Limpar')}}</b-button>
    </p>
  </div>
</template>
<script>
import moment from "moment";

export default {
  props: ["value", "method", "locale", "tabs", "ctl_filters"],
  data() {
    return {
      display: "inline",
      filter_text: "Filtros",
      filter_icon: "filter",
      set_filters: this.ctl_filters
    };
  },
  methods: {
    remove(index) {
      var clonedValue = this.value;
      clonedValue[index] = null;
      this.$cookies.remove(index);
      this.method();
    },
    removeAll() {
      for (const key in this.value) {

        if (key != "p_open") {
          this.value[key] = null;
          this.$cookies.remove(key);
        }
      }
      this.set_filters = false;
      this.ctl_filters = false;
      this.method();

    }
  },
  filters: {
    formatDate: function(value, loc) {
      if (value) {

        if (moment(value, "YYYY-MM-DD", true).isValid()) {
          if (loc != "US") {
            return moment(String(value)).format("DD/MM/YYYY");
          } else {
            return value;
          }
        } else {
          return value;
        }
      }
    }
  },
  watch: {
    set_filters: function(value) {
      if (typeof value == "string") {
        this.filter_text = "Filtros Aplicados";
        this.filter_icon = "search";
      } else {
        this.filter_text = "Filtros";
        this.filter_icon = "filter";
      }
    }
  }
};
</script>

<style scoped>
.wrap-badge {
  word-break: break-all;
  white-space: normal;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders/TagList.vue